module.exports = __webpack_public_path__ + "media/src/shared_components/images/ellipsis-v_icon-2846d8ce43318e2bffec960aa19ae998.svg";